import { Link } from "react-router-dom"
import Paginator from "../../components/Paginator"
import Search from "../../components/Search"
import StandardLayout from "../../components/StandardLayout"
import { removeEmpties } from "../../helper"
import { useAreeList } from "../../hooks/area"
import { useQsFilters } from "../../hooks/useFilters"

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get("page") ?? 1),
  search: params.get("search") ?? "",
  tipo: params.get("tipo") ?? "",
})

const Aree = () => {
  const { filters, uiFilters, setFilters, setFiltersDebounced } = useQsFilters(initFilters)

  const { data: aree } = useAreeList(
    removeEmpties({
      search: filters.search,
      page: String(filters.page),
      tipo: filters.tipo,
    })
  )

  return (
    <StandardLayout>
      <div className="sticky-header bg-light p-3 shadow-sm">
        <div className="d-flex justify-content-between">
          <div>
            <div className="page-title">
              <Link to="/dati-base">{"Dati di base"}</Link>
              {filters?.tipo ? (
                <>
                  {" / "}
                  <Link to={`/dati-base/aree/list`} state={{ filter: undefined }}>
                    {"Aree"}
                  </Link>
                  {` - ${filters?.tipo ?? ""}`}
                </>
              ) : (
                <>{" / Aree"}</>
              )}
            </div>
          </div>
          <Search
            value={uiFilters.search}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              setFiltersDebounced({ search: e.currentTarget.value, page: 1 })
            }
          />
        </div>
      </div>

      <div className="p-3">
        {aree ? (
          <div className="">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>{"Loc ref."}</th>
                  <th>{"Area"}</th>
                  <th>{"Area Contabilizzata"}</th>
                </tr>
              </thead>
              <tbody>
                {aree.results.map((area) => (
                  <tr key={area.loc_ref}>
                    <td>{area.loc_ref}</td>
                    <td>{area.area_calc}</td>
                    <td>{area.area_contab}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>

      <div className="sticky-footer bg-light border-top">
        <Paginator count={aree?.count ?? 0} currentPage={uiFilters.page} goToPage={(page) => setFilters({ page })} />
      </div>
    </StandardLayout>
  )
}

export default Aree
